import React, { useEffect, useRef, useState } from 'react'
import { AddonSheet, Sheet } from '../../models/_models'
import classes from './droppable-area.module.sass'
import Sheets from './Sheets'
import PreviewImage from '../PreviewImage';
import cn from 'classnames';

const DroppableArea = ({
  addons = false,
  placeholder,
  checkForeground = true,
  newForeground,
  newBackground,
  mouseCoordinates,
  checkBounds,
  imageType,
  poses = false,
  prefillSheet,
  setSheets = () => { },
  fillStyle,
  isBgRequired = true,
  removeForeground = false,
  onForegroundSelection = () => true,
  onSheetComplete = () => { },
  mouseEvent,
  editable = true,
}) => {
  const ref = useRef(null)
  const [foreground, setForeground] = useState(prefillSheet ? (poses ? prefillSheet.pose : prefillSheet.seniorImage) : null)
  const [background, setBackground] = useState(prefillSheet ? prefillSheet.background : null)

  const className = {
    [classes.droppable]: true,
    [classes[imageType.classname]]: true,
    [classes.noContent]: foreground === null && background === null,
  }

  const getLength = (classname) => {
    switch (classname) {
      case 'fivebyseven':
        return 2
      case 'threebyfive':
        return 4
      case 'wallets':
        return 8
      default:
        return 1
    }
  }

  const isInBounds = () => {
    if (!mouseEvent) return false

    let x = 0
    let y = 0

    if (mouseEvent.clientX && mouseEvent.clientY) {
      x = mouseEvent.clientX
      y = mouseEvent.clientY
    } else {
      x = mouseEvent.touches[0].clientX
      y = mouseEvent.touches[0].clientY
    }

    const {
      top,
      right,
      bottom,
      left,
    } = ref.current.getBoundingClientRect()

    return (
      left <= x
      && right >= x
      && top <= y
      && bottom >= y
    )
  }

  useEffect(() => {
    if (removeForeground) setForeground(null)
  }, [removeForeground])

  useEffect(() => {
    if (!foreground) return

    const res = onForegroundSelection(foreground, prefillSheet.index)

    if (!res) setForeground(null)
  }, [foreground])

  useEffect(() => {
    if (!checkBounds) return
    if (!isInBounds()) return

    if (newForeground) setForeground(newForeground)
    if (newBackground) setBackground(newBackground)
  }, [checkBounds, newForeground, newBackground])

  useEffect(() => {
    if (!editable) return
    if (!(foreground && (!isBgRequired || background))) return

    let newSheet
    if (addons) {
      const newAttributes = {
        seniorImageId: foreground && foreground.id,
        seniorImage: typeof foreground === 'string' ? null : foreground,
        pose: typeof foreground === 'string' ? null : foreground,
        addonId: imageType.addonId,
        backgroundId: background && background.id,
        background,
        index: prefillSheet.index,
      }

      if (prefillSheet.id) {
        prefillSheet.attributes = newAttributes
        newSheet = prefillSheet
      } else {
        newSheet = new AddonSheet(newAttributes)
      }
    } else if (poses) {
      const newAttributes = {
        poseId: foreground && foreground.id,
        backgroundId: background && background.id,
        imageTypeId: imageType.id,
        pose: typeof foreground === 'string' ? null : foreground,
        background,
        index: prefillSheet.index,
      }

      if (prefillSheet.id) {
        prefillSheet.attributes = newAttributes
        newSheet = prefillSheet
      } else {
        newSheet = new Sheet(newAttributes)
      }
    } else {
      const newAttributes = {
        seniorImageId: foreground.id,
        backgroundId: background && background.id,
        imageTypeId: imageType.id,
        seniorImage: foreground,
        background,
        index: prefillSheet.index,
      }

      if (prefillSheet.id) {
        prefillSheet.attributes = newAttributes
        newSheet = prefillSheet
      } else {
        newSheet = new Sheet(newAttributes)
      }
    }

    onSheetComplete(newSheet)

    setSheets((prev) => {
      const newSheets = [...prev]
      newSheets[prefillSheet.index] = newSheet

      return newSheets
    })
  }, [foreground, background])

  return (
    <div className={classes.container}>
      <div ref={ref} className={cn(className)}>
        {new Array(getLength(imageType.classname)).fill(0).map((_, i) => i).map((key) => (
          <PreviewImage
            key={key}
            // isPreviewHidden={false}
            foregroundUrl={checkForeground ? (foreground && foreground.watermarkUrl) : placeholder}
            backgroundUrl={background && background.imageUrl}
          />
        ))}
      </div>
    </div>
  )
}

export default DroppableArea
